<br><br><br><br>
<div class="page-title">
  <h1 class="title-text">Accident PDFs</h1>
  <p class="form-desc"></p>
</div>

<div class="sse-hub-container">
  <div class="search-container">
    <mat-form-field class="search-input">
      <mat-label>Search...</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="" #filterInput>
    </mat-form-field>
  </div>

  @if (loading) {
    <div class="loading-spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }

  @if (error) {
    <div class="error-message">
      <mat-icon color="warn">error</mat-icon>
      <span>{{ error }}</span>
    </div>
  }

  @if (!loading && !error) {
    <div>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="dateOfAccident">
          <th mat-header-cell *matHeaderCellDef>
            Date of Accident
            <button class="custom-menu-button" [matMenuTriggerFor]="dateMenu">
              &#x22EE;
            </button>
            <mat-menu #dateMenu="matMenu" class="custom-menu">
              <button mat-menu-item (click)="sortData('asc')">Sort Ascending</button>
              <button mat-menu-item (click)="sortData('desc')">Sort Descending</button>
              <button mat-menu-item (click)="clearSort()">Clear Sorting</button>
            </mat-menu>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.dateOfAccident | date:'MM/dd/yyyy' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="repEmploy">
          <th mat-header-cell *matHeaderCellDef> Reporting Employee </th>
          <td mat-cell *matCellDef="let element"> {{ element.repEmploy }} </td>
        </ng-container>
        <ng-container matColumnDef="fileUrl">
          <th mat-header-cell *matHeaderCellDef> PDF Summary </th>
          <td mat-cell *matCellDef="let element">
            <a [href]="element.fileUrl" target="_blank" class="download-link">Download Summary</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="attachedFiles">
          <th mat-header-cell *matHeaderCellDef> Attached Files </th>
          <td mat-cell *matCellDef="let element">
            @if (element.attachedFiles?.length > 0) {
              @for (file of element.attachedFiles; track file; let i = $index) {
                <div class="file-link-wrapper">
                  <mat-icon class="file-icon">attach_file</mat-icon>
                  <a [href]="file.fileUrl" target="_blank" class="download-link">{{file.fileName}}</a>
                </div>
              }
            } @else {
              <span class="no-files-text">No files attached</span>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
      </table>
      @if (dataSource.filteredData.length === 0) {
        <div class="no-data-message">
          <mat-icon color="primary">info</mat-icon>
          <span>No data available.</span>
        </div>
      }
    </div>
  }
</div>
